import React, { useEffect } from "react"
import Header from "../components/Header"
import Footer from "../components/Footer"
import { CookiesProvider } from "react-cookie"
import GclidCookie from "src/utils/GclidCookie"
import FbclidCookie from "src/utils/FbclidCookie"
import LifatidCookie from "src/utils/LifatidCookie"

const Index = ({ children }) => {
  //https://github.com/tailwindlabs/tailwindcss/discussions/1610#discussioncomment-352836
  //gets screen size - to fix mobile viewport height problem
  useEffect(() => {
    if (typeof window !== "undefined") {
      function handleResize() {
        const vh = window.innerHeight * 0.01
        document.documentElement.style.setProperty("--vh", `${vh}px`)
      }

      window.addEventListener("resize", handleResize)

      handleResize()

      return () => window.removeEventListener("resize", handleResize)
    }
  }, [])

  return (
    <React.Fragment>
      <Header />
      <CookiesProvider>
        <GclidCookie />
        <FbclidCookie />
        <LifatidCookie />
        <main className="mt-[86px] xl:mt-[101px]">{children}</main>
      </CookiesProvider>
      <Footer></Footer>
    </React.Fragment>
  )
}

export default Index
